import * as React from "react";

export default class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {}
    }
  }

  initFormData(formData) {
    this.setState({
      formData: formData
    })
  }

  setField(field, value) {
    let prevFormData = this.state.formData
    prevFormData[field] = value
    this.setState({
      formData: prevFormData
    })
  }
}



// WEBPACK FOOTER //
// ./src/theme/Form.js